var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMaximize = function SvgMaximize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.65 15.554a.6.6 0 0 1 .599.6v3.116a1.48 1.48 0 0 0 1.479 1.478h3.117a.6.6 0 0 1 0 1.2H4.728A2.68 2.68 0 0 1 2.05 19.27v-3.117a.6.6 0 0 1 .6-.6m18.702 0a.6.6 0 0 1 .6.6v3.116a2.68 2.68 0 0 1-2.679 2.678h-3.117a.6.6 0 0 1 0-1.2h3.117a1.48 1.48 0 0 0 1.478-1.478v-3.117a.6.6 0 0 1 .6-.6M7.845 2.047a.6.6 0 0 1 0 1.2H4.728a1.48 1.48 0 0 0-1.479 1.478v3.117a.6.6 0 0 1-1.2 0V4.725a2.68 2.68 0 0 1 2.679-2.678zm11.428 0a2.68 2.68 0 0 1 2.678 2.678v3.117a.6.6 0 0 1-1.2 0V4.725a1.48 1.48 0 0 0-1.478-1.479h-3.117a.6.6 0 0 1 0-1.2z"
  })));
};
export default SvgMaximize;